import React, { useState, useEffect, useContext } from 'react';
import { useSelector, connect } from 'react-redux';
import {
	apiKey,
	sessionId,
	generatedAdminToken,
} from '../../constants/videoCall';
import { useHistory, withRouter, useLocation, Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import { VideoCallModal } from './VideoCallModal';
import { FirebaseContext } from '../../context/firebase';
import Sidebar from '../layout/sidebar/Sidebar';
import PanToolIcon from '@material-ui/icons/PanTool';
import ScreenShareIcon from '@material-ui/icons/ScreenShare';
import StopScreenShareIcon from '@material-ui/icons/StopScreenShare';
import * as PROJECT_CODE from '../../constants/projectCode';
import Spinner from '../layout/spinner/Spinner';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import './VideoCall.css';
import './Modal.css';

import {
	stopStreaming,
	initializeSession,
	toggleAudio,
	toggleVideo,
	toggleAudioSubscription,
	toggleVideoSubscription,
	toggleScreenShare,
	switchCamera,
	startFurioos,
	callFurioos,
	furioosImplementation,
	togglePresentation,
	stopPresentation,
	didIPressPresent,
	changeToHostPose,
	didMaterportStartedLoading,
	didMatterportLoaded,
	callMatterPort,
	raiseHand,
	settingsModal,
	shareScreen,
	handleLeaveVideoCall,
} from './VonageVideoApiIntegration';

// material ui icons imports
import MicIcon from '@material-ui/icons/Mic';
import MicOffIcon from '@material-ui/icons/MicOff';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import CallEndIcon from '@material-ui/icons/CallEnd';
import FlipCameraIosIcon from '@material-ui/icons/FlipCameraIos';
import SettingsVoiceIcon from '@material-ui/icons/SettingsVoice';
import SettingsIcon from '@material-ui/icons/Settings';
import Select from '@material-ui/core/Select';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';

import notificationAudio from '../../assets/notificationAudio.mp3';

import { ToastContainer, toast, Zoom, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	Tooltip,
	Button,
	Menu,
	MenuItem,
	CircularProgress,
} from '@material-ui/core';

import { handleSubscription } from '../../actions/videoCall';
import { TramOutlined } from '@material-ui/icons';

const VideoCall = ({
	handleSubscription,
	connectionCount: connectionCount,
	loading,
	props,
	disabledShareScreenBtn
}) => {
	const [isInterviewStarted, setIsInterviewStarted] = useState(true);
	const [isAudioEnabled, setIsAudioEnabled] = useState(true);
	const [isVideoEnabled, setIsVideoEnabled] = useState(true);
	const [isAudioSubscribed, setIsAudioSubscribed] = useState(true);
	const [isVideoSubscribed, setIsVideoSubscribed] = useState(true);
	const [isStreamSubscribed, setIsStreamSubscribed] = useState(false);
	const [isPresenting, setIsPresenting] = useState(false);
	const [isScreenSharing, setIsScreenSharing] = useState(false);
	const [pending, setPending] = useState(true);
	const [copied, setCopied] = useState(false);
	const [userType, setUserType] = useState('');

	const location = useLocation();
	// const prevLocation = usePrevious(location);

	const { firebase } = useContext(FirebaseContext);

	//modal
	const [show, setShow] = useState(false);

	//menu
	const [anchorEl, setAnchorEl] = useState(null);
	const handleClose = () => {
		setAnchorEl(null);
	};
	const openMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const [formData, setFormData] = useState({
		audio: '',
		video: '',
		audiooutput: '',
	});

	const { audio, video, audiooutput } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const isSubscribed = useSelector(
		(state) => state.videoCall.isStreamSubscribed
	);

	const getProjectId = (id) => {
		console.log(id);
	};
	console.log('VIDEO CALL SHORT CODE ' + location.state.detail.shortCode);
	const checkStateOfPresentation = () => {
		var tempAppCode = location.state.detail.thisAppointmentCode;

		var isMatterportLoaded, hostPoseX, hostPoseY, hostPoseZ;

		firebase
			.database()
			.ref('/ongoing_meetings/' + PROJECT_CODE.projectCode)
			.child(tempAppCode)
			.on('value', (snapshot) => {
				if (snapshot.val() != null) {
					var hasMeetingStarted = snapshot.val().started;
					var whatIsGoingToBePresented = snapshot.val().whatToPresent;

					var isMatterportLoaded;
					var matterportStartedLoading;
					var furioosInfo = createFurioosInfo();

					isMatterportLoaded = didMatterportLoaded();
					matterportStartedLoading = didMaterportStartedLoading();

					console.log('before joining');

					if (hasMeetingStarted && whatIsGoingToBePresented.length <= 7) {
						console.log('SHOULD BE CALLING FURIOOS');
						callFurioos(whatIsGoingToBePresented, furioosInfo);

						console.log('start joining');
					} else if (
						hasMeetingStarted == true &&
						matterportStartedLoading == false &&
						whatIsGoingToBePresented.length > 7
					) {
						console.log('joined matt');
						console.log(
							'where matterport is called; ' +
								hasMeetingStarted +
								' ' +
								matterportStartedLoading +
								' ' +
								whatIsGoingToBePresented.length
						);
						callMatterPort(whatIsGoingToBePresented);
					} else if (hasMeetingStarted == false) {
						stopPresentation();
					} else {
						console.log(
							'neither furios nor matterport started ' +
								hasMeetingStarted +
								' ' +
								matterportStartedLoading +
								' ' +
								whatIsGoingToBePresented.length
						);
						console.error('Neither furioos nor matterport started.');
					}

					if (
						isMatterportLoaded == true &&
						snapshot.child('host') != null &&
						whatIsGoingToBePresented.length > 7
					) {
						console.log('Get host info');
						var hostShot = snapshot.child('host');

						console.log(
							'get host info and host pose ' +
								hasMeetingStarted +
								' ' +
								matterportStartedLoading +
								' ' +
								whatIsGoingToBePresented.length
						);

						console.log('HOST POSE ' + hostShot.child('pose').val().x);

						var hostPoseX = hostShot.child('pose').val().x;
						var hostPoseY = hostShot.child('pose').val().y;
						var hostPoseZ = hostShot.child('pose').val().z;

						var hostRotX = hostShot.child('rot').val().x;
						var hostRotY = hostShot.child('rot').val().y;
						var hostSweep;

						if (hostShot.child('pose').val().sweep != undefined) {
							hostSweep = hostShot.child('pose').val().sweep;
						}

						//hostRotZ = hostShot.child('rot').val().z ;
						console.log('THIS HOST SWEET FROM FIREBASE ' + hostSweep);
						console.log(
							'host pose ' + hostPoseX + ', ' + hostPoseY + ', ' + hostPoseZ
						);
						console.log('host rot ' + hostRotX + ', ' + hostRotY);

						if (hasMeetingStarted === true) {
							console.log(
								'has meeting started is true ' +
									hasMeetingStarted +
									' ' +
									matterportStartedLoading +
									' ' +
									whatIsGoingToBePresented.length
							);
							console.log('has meeting started is true');
							console.log('i press present ' + iPressedPresent);
							console.log('ismatterport loaded ' + isMatterportLoaded);
							var iPressedPresent = didIPressPresent();
							if (isMatterportLoaded && iPressedPresent === false) {
								changeToHostPose(
									hostPoseX,
									hostPoseY,
									hostPoseZ,
									hostRotX,
									hostRotY,
									hostSweep
								);
							}
						}
					}
				} else {
					var StartRef = firebase
						.database()
						.ref(
							'/ongoing_meetings/' +
								PROJECT_CODE.projectCode +
								'/' +
								tempAppCode
						);

					//If that snapashot is null this means no one has entered this meeting yet

					var startMeetingData = {
						started: false,
						whatToPresent: 'nothing',
						host: {
							pose: {
								sweep: ' ',
								x: 0,
								y: 0,
								z: 0,
							},
							rot: {
								x: 0,
								y: 0,
							},
						},
					};

					StartRef.set(startMeetingData);
				}
			});
	};

	const createFurioosInfo = () => {
		var info = {
			user_email: location.state.detail.thisEmail,
			user_name: location.state.detail.thisName,
			user_phone: location.state.detail.thisPhone,
			user_avatar: 'e5fe5968-058c-494b-8e8f-ca95425a2a02',
			user_time: location.state.detail.thisAppointmentTime,
			img_file: ' ',
			user_type: location.state.detail.thisUserType,
			appointmentId: location.state.detail.thisAppointmentCode,
			user_id: location.state.detail.thisUID,
			callBack: () => {
				console.log('furioos has finished');
			},
			iFrameName: 'furioosContainer',
		};

		console.log('this is the info: ' + JSON.stringify(info));
		return info;
	};

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var currentUserType;
				var capFirst;

				console.log('Current user Id; ' + currentUserId);
				await firebase
					.database()
					.ref('/users/' + currentUserId + '/userType')
					.once('value', function (snapshot) {
						currentUserType = snapshot.val();
						console.log('THIS IS USER TYPE: ' + currentUserType);
					});
				setUserType(currentUserType);
			}
		});
	}, [userType]);

	// Check is video is enabled or not then decide whether to setIsVideoEnabled to true or false
	useEffect(() => {
		var tempAppCode = location.state.detail.thisAppointmentCode;
		firebase
			.database()
			.ref('/ongoing_meetings/' + PROJECT_CODE.projectCode + '/' + tempAppCode)
			.on('value', (snapshot) => {
				var videoState = true;
				if (snapshot.val() != null) {
					console.log('isVideoEnabled: ' + snapshot.val().isVideoEnabled);

					videoState = snapshot.val().isVideoEnabled;
				}

				if (videoState === false) {
					setIsVideoEnabled(false);
				} else {
					setIsVideoEnabled(true);
				}
			});

		console.log('togglePresentation', togglePresentation);
		console.log('togglePresentation isPresenting', isPresenting);
		//redirect to home if refresh on preview page
		// if (window.performance.navigation.type == 1) {
		// 	window.location.href = '/';
		// }
	}, []);

	useEffect(() => {
		var tempAppCode = location.state.detail.thisAppointmentCode;
		generatedAdminToken(function (token) {
			firebase.auth().onAuthStateChanged(function (user) {
				var info = createFurioosInfo();

				console.log('This is the info from generatedAdminToken: ' + info);
				// checkStateOfPresentation();

				const initMeeting = () => {
					initializeSession(apiKey, sessionId, token, info, getProjectId);
					setPending(false);
					checkStateOfPresentation();
				};

				isInterviewStarted ? initMeeting() : stopStreaming(tempAppCode);
			});
		}, location.state.detail.thisAppointmentCode);
	}, [isInterviewStarted, initializeSession]);

	useEffect(() => {
		setIsStreamSubscribed(isSubscribed);
	}, [isSubscribed]);

	useEffect(() => {
		return () => {
			handleLeaveVideoCall();
		};
	}, []);

	const onToggleAudio = (action) => {
		setIsAudioEnabled(action);
		toggleAudio(action);
	};

	const onTogglePresentation = (action) => {
		console.log('On toggle presentation');
		var tempAppCode = location.state.detail.thisAppointmentCode;
		togglePresentation(action, tempAppCode, () => {
			console.log('TOGGLE PRESENTATION IS PRESENTING SET TO ' + action);
			setIsPresenting(action);
		});

		if (isScreenSharing === true) {
			onToggleScreenShare(false);
		}
	};

	const onToggleScreenShare = (action) => {
		toggleScreenShare(action, (value) => {
			console.log('On toggle screen share callback', action);
			setIsScreenSharing(value);
		});

		if (isPresenting === false) {
			onTogglePresentation(true);
		}
	};

	const onToggleVideo = (action) => {
		setIsVideoEnabled(action);
		toggleVideo(action);
	};

	const onToggleAudioSubscription = (action) => {
		setIsAudioSubscribed(action);
		toggleAudioSubscription(action);
	};

	const onToggleVideoSubscription = (action) => {
		setIsVideoSubscribed(action);
		toggleVideoSubscription(action);
	};

	const closeModalHandler = () => setShow(false);

	const history = useHistory();

	const renderToolbar = () => {
		return (
			<>
				{isInterviewStarted && (
					<div id='video-toolbar' className={'video-toolbar'}>
						{isStreamSubscribed && (
							<>
								{isAudioSubscribed ? (
									<Tooltip title='Turn Sound Off'>
										<VolumeUpIcon
											onClick={() => onToggleAudioSubscription(false)}
											className='on-icon'
										/>
									</Tooltip>
								) : (
									<Tooltip title='Turn Sound On'>
										<VolumeOffIcon
											onClick={() => onToggleAudioSubscription(true)}
											className='off-icon'
										/>
									</Tooltip>
								)}
								{/* {isVideoSubscribed ? (
									<Tooltip title='Turn screen off'>
										<VisibilityIcon
											onClick={() => onToggleVideoSubscription(false)}
											className='on-icon'
										/>
									</Tooltip>
								) : (
									<Tooltip title='turn screen on'>
										<VisibilityOffIcon
											onClick={() => onToggleVideoSubscription(true)}
											className='off-icon'
										/>
									</Tooltip>
								)} */}
							</>
						)}
						{isAudioEnabled ? (
							<Tooltip title='Mute'>
								<MicIcon
									onClick={() => onToggleAudio(false)}
									className='on-icon'
								/>
							</Tooltip>
						) : (
							<Tooltip title='Unmute'>
								<MicOffIcon
									onClick={() => onToggleAudio(true)}
									className='off-icon'
								/>
							</Tooltip>
						)}
						{isVideoEnabled ? (
							<Tooltip title='Turn Off Camera'>
								<VideocamIcon
									onClick={() => onToggleVideo(false)}
									className='on-icon'
								/>
							</Tooltip>
						) : (
							<Tooltip title='Turn On Camera'>
								<VideocamOffIcon
									onClick={() => onToggleVideo(true)}
									className='off-icon'
								/>
							</Tooltip>
						)}
						{isInterviewStarted ? (
							<Tooltip title='Switch Webcam'>
								<FlipCameraIosIcon
									onClick={() => {
										switchCamera();
									}}
									className='on-icon'
								/>
							</Tooltip>
						) : (
							<></>
						)}
						{isInterviewStarted ? (
							<Tooltip title='Raise hand'>
								<PanToolIcon
									className='on-icon'
									id='raise-hand-btn'
									onClick={() => raiseHand()}
								/>
							</Tooltip>
						) : (
							<></>
						)}
						{isInterviewStarted ? (
							<Tooltip title='Hang Up'>
								<CallEndIcon
									onClick={() => {
										setIsInterviewStarted(false);
										stopStreaming(location.state.detail.thisAppointmentCode);

										history.push('/');
									}}
									className='off-icon'
								/>
							</Tooltip>
						) : (
							<></>
						)}
						{(userType === 'admin' || userType === 'superadmin') && (
							<>
								{isPresenting && isInterviewStarted ? (
									<Tooltip title='Projects'>
										<Button
											onClick={openMenu}
											aria-controls='project-menu'
											aria-haspopup='true'
											id='projects-btn'
										>
											<PresentToAllIcon
												className='projectBtn'
												id='projectBtn'
												onClick={() => onTogglePresentation(!isPresenting)}
											/>
										</Button>
									</Tooltip>
								) : (
									<Tooltip title='Projects'>
										<Button id='projects-off-btn'>
											<PresentToAllIcon
												className='projectBtn'
												id='projectBtn'
												onClick={() => onTogglePresentation(!isPresenting)}
											/>
										</Button>
									</Tooltip>
								)}
							</>
						)}

						{(userType === 'admin' ||
							userType === 'superadmin' ||
							userType === 'client') && (
							<>
								{!isScreenSharing ? (
									<Tooltip title='Share Screen'>
										<Button disabled={disabledShareScreenBtn}>
											{disabledShareScreenBtn ? (
												<StopScreenShareIcon
													className='off-icon'
													id='screen-share-btn'
													onClick={() => {
														onToggleScreenShare(true);
													}}
												/>
											) : (
												<ScreenShareIcon
													className='on-icon'
													id='screen-share-btn'
													onClick={() => {
														onToggleScreenShare(true);
													}}
												/>
											)}
										</Button>
									</Tooltip>
								) : (
									<Tooltip title='Share Screen'>
										<Button disabled={disabledShareScreenBtn}>
											{disabledShareScreenBtn ? (
												<StopScreenShareIcon
													className='off-icon'
													id='screen-share-btn'
													onClick={() => {
														onToggleScreenShare(false);
													}}
												/>
											) : (
												<ScreenShareIcon
													className='off-icon'
													id='screen-share-btn'
													onClick={() => {
														onToggleScreenShare(false);
													}}
												/>
											)}
										</Button>
									</Tooltip>
								)}
								{isInterviewStarted ? (
									<Tooltip title='Settings'>
										<SettingsIcon
											className='on-icon'
											id='settings-btn'
											onClick={() => settingsModal()}
										/>
									</Tooltip>
								) : (
									<></>
								)}
							</>
						)}
					</div>
				)}
			</>
		);
	};

	return (
		<div className='video-page'>
			<Sidebar />
			<Prompt
				message={() => {
					console.log('Leaving video call with prompt');
					handleLeaveVideoCall();
				}}
			/>

			<Menu
				id='project-menu'
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{ padding: '0 3em' }}
				onClick={handleClose}
			></Menu>
			{show ? (
				<div className='back-drop' onClick={closeModalHandler}></div>
			) : null}
			<div className='video-container' id='layout'>
				<VideoCallModal show={show} close={closeModalHandler} title='Settings'>
					<div className='selectors'>
						<div className='meeting_code_wrapper'>
							<label>Meeting Code: {location.state.detail.shortCode}</label>
							<span>
								<CopyToClipboard
									text={location.state.detail.shortCode}
									onCopy={() => setCopied(true)}
								>
									<Tooltip title='Copy to clipboard'>
										<FileCopyIcon />
									</Tooltip>
								</CopyToClipboard>
							</span>
						</div>
						<br />
						<br />

						<label htmlFor='audio-source-select-preview'>Microphone: </label>
						<select
							name='audio'
							value={audio}
							onChange={(e) => onChange(e)}
							id='audio-source-select-preview'
						></select>
						<br />
						<div id='audio-meter-preview'>
							<label for='audio-meter-preview'>Microphone Level:</label>
							<meter min='0' max='1'></meter>
						</div>
						<br />

						<label htmlFor='video-source-select-preview'>Webcam: </label>
						<select
							name='video'
							value={video}
							onChange={(e) => onChange(e)}
							id='video-source-select-preview'
						></select>
					</div>
				</VideoCallModal>
				<audio
					id='notificationAudio'
					src={notificationAudio}
					preload='auto'
				></audio>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<div id='preview-background'></div>

				<div id='previewContainer'>
					<div id='preview' className='previewVideo'></div>
					<div className='video-preview-right'>
						{pending && (
							<CircularProgress
								style={{ position: 'absolute', left: '50%', top: '15%' }}
							/>
						)}
						<h2>Meeting Ready</h2>
						<button id='join-meeting' className='btn btnJoinMeeting'>
							Join meeting
						</button>
						<br />
						<button
							onClick={() => setShow(true)}
							className='btn-openModal btn btnSettings'
						>
							Settings
						</button>
						<br />
						<button id='join-without-video'>Join without video</button>
					</div>
				</div>

				<div id='modal-drop'></div>
				<div id='deviceSettingsModal'>
					<div className='modalSelectors'>
						<div className='modal-title'>
							<h2>Settings</h2>
						</div>
						<div className='meeting_code_wrapper'>
							<label>Meeting Code: {location.state.detail.shortCode}</label>
							<span>
								<CopyToClipboard
									text={location.state.detail.shortCode}
									onCopy={() => setCopied(true)}
								>
									<Tooltip title='Copy to clipboard'>
										<FileCopyIcon />
									</Tooltip>
								</CopyToClipboard>
							</span>
						</div>
						<br />
						<br />
						<label htmlFor='audio-source-select-modal'>Microphone: </label>
						<select
							name='audio'
							value={audio}
							onChange={(e) => onChange(e)}
							id='audio-source-select-modal'
						></select>
						<br />
						<div id='audio-meter-modal'>
							<label for='audio-meter-modal'>Microphone Level:</label>
							<meter min='0' max='1'></meter>
						</div>
						{/* <label htmlFor='audio-output-select-modal'>Speaker: </label>
						<select
							name='audiooutput'
							value={audiooutput}
							onChange={(e) => onChange(e)}
							id='audio-output-select-modal'
						></select> */}
						<br />
						<label htmlFor='video-source-select-modal'>Webcam: </label>
						<select
							name='video'
							value={video}
							onChange={(e) => onChange(e)}
							id='video-source-select-modal'
						></select>
						<br />
						<button id='btn-close'>Close</button>
					</div>
				</div>

				<div
					id='subscriber'
					className={`${
						isStreamSubscribed
							? 'main-video subscriberVideo'
							: 'additional-video subscriberVideo'
					}`}
				>
					<div id='furioosContainer'></div>
					<div id='screen-preview'></div>
					<iframe
						src=''
						id='mattaPortIframe'
						className='mattaPortIframe'
						frameborder='0'
					></iframe>
				</div>

				{!isStreamSubscribed && renderToolbar()}
				{isStreamSubscribed && renderToolbar()}
				{/* <div
                id="publisher"
                className={`${
                    isStreamSubscribed ? "additional-video" : "main-video"
                }`}
                >
                {!isStreamSubscribed && renderToolbar()}
                </div> */}
			</div>
		</div>
	);
};

VideoCall.propTypes = {
	handleSubscription: PropTypes.bool.isRequired,
	connectionCount: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
	handleSubscription: state.handleSubscription,
	connectionCount: state.connectionCount,
	disabledShareScreenBtn: state.videoCall.disabledShareScreenBtn
});

export default connect(mapStateToProps)(VideoCall);
